import { GetSupportPayload, GetSupportResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../../services/core-api-service";

class GetSupportDialogContentsService {
    public async requestSupport(assessmentId: string, payload: GetSupportPayload): Promise<GetSupportResult> {
        return api.assessments.getSupport(assessmentId, payload)
    }
}

export const service = new GetSupportDialogContentsService()